<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.AmmunitionStock">Ammunition Stock</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">

        <mat-form-field matTooltip="Select a Business Unit from the list" [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.AmmunitionStock.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnitFilterInput"              
              (ngModelChange)="businessUnitChanging($event)" [(ngModel)]="businessUnitFilter"              
              (ngModelChange)="businessUnitChanged($event)" #businessUnitFilterInput              
              placeholder="Business Unit" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnitDisplay(businessUnit)}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Cost Centre from the list" [matTooltipDisabled]="disabledTooltip(this.costCentre)">
          <mat-label i18n="@@type.AmmunitionStock.costCentre">Cost Centre</mat-label>
          <mat-select formControlName="costCentre" id="costCentreFilterInput"              
              (ngModelChange)="costCentreChanging($event)" [(ngModel)]="costCentreFilter"              
              (ngModelChange)="costCentreChanged($event)" #costCentreFilterInput              
              placeholder="Cost Centre" [compareWith]="costCentreCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let costCentre of costCentreSelectionList" [value]="costCentre">
              {{costCentreDisplay(costCentre)}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a value from the list" [matTooltipDisabled]="disabledTooltip(this.closed)">
          <mat-label i18n="@@type.AmmunitionStock.closed">Closed</mat-label>
          <mat-select formControlName="closed" id="closedFilterInput"              
              (ngModelChange)="closedChanging($event)" [(ngModel)]="closedFilter"              
              (ngModelChange)="closedChanged($event)" #closedFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

        
        <mat-form-field matTooltip="Select a value from the list" [matTooltipDisabled]="disabledTooltip(this.hasPendingIssueAcknowledgements)">
          <mat-label i18n="@@type.AmmunitionStock.hasPendingIssueAcknowledgements">Has Pending Issue Acknowledgements</mat-label>
          <mat-select formControlName="hasPendingIssueAcknowledgements" id="hasPendingIssueAcknowledgementsFilterInput"              
              (ngModelChange)="hasPendingIssueAcknowledgementsChanging($event)" [(ngModel)]="hasPendingIssueAcknowledgementsFilter"              
              (ngModelChange)="hasPendingIssueAcknowledgementsChanged($event)" #hasPendingIssueAcknowledgementsFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Calibre" [matTooltipDisabled]="disabledTooltip(this.calibre)">
          <mat-label i18n="@@type.AmmunitionStock.calibre">Calibre</mat-label>
          <input matInput formControlName="calibre" id="calibreFilterInput"              
              (ngModelChange)="calibreChanging($event)" [(ngModel)]="calibreFilter"              
              (ngModelChange)="calibreChanged($event)" #calibreFilterInput              
              maxlength="255" placeholder="Calibre">
        </mat-form-field>
		
        <mat-form-field matTooltip="Make" [matTooltipDisabled]="disabledTooltip(this.make)">
          <mat-label i18n="@@type.AmmunitionStock.make">Make</mat-label>
          <input matInput formControlName="make" id="makeFilterInput"              
              (ngModelChange)="makeChanging($event)" [(ngModel)]="makeFilter"              
              (ngModelChange)="makeChanged($event)" #makeFilterInput              
              maxlength="255" placeholder="Make">
        </mat-form-field>

        <mat-form-field matTooltip="Weight" [matTooltipDisabled]="disabledTooltip(this.weight)">
          <mat-label i18n="@@type.AmmunitionStock.weight">Weight</mat-label>
          <input matInput formControlName="weight" id="weightFilterInput"              
              (ngModelChange)="weightChanging($event)" [(ngModel)]="weightFilter"              
              (ngModelChange)="weightChanged($event)" #weightFilterInput              
              maxlength="255" placeholder="Weight">
        </mat-form-field>
		
      </div>
      
      <div class="search-section">

		<mat-slide-toggle floatLabel="always" appearance="none" color="primary"  *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch"  [ngModelOptions]="{standalone: true}">
            Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>
		  

        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>
			
    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort
                           matSortDirection="asc" matSortDisableClear cdkDropList cdkDropListLockAxis="x"
                           cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="ammunitionStockId">
            <mat-header-cell [crud-column-header]="columns.column('ammunitionStockId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStock.ammunitionStockId">
                Ammunition Stock Id 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.ammunitionStockId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="businessUnit.buId">
            <mat-header-cell [crud-column-header]="columns.column('businessUnit.buId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStock.businessUnit">
                Business Unit 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.businessUnit?.buId}} - {{element.businessUnit?.name}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="costCentre.ccId">
            <mat-header-cell [crud-column-header]="columns.column('costCentre.ccId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStock.costCentre">
                Cost Centre 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.costCentre?.ccId}} - {{element.costCentre?.name}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="calibre">
            <mat-header-cell [crud-column-header]="columns.column('calibre')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStock.calibre">
                Calibre 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.calibre | refDecode:'FIREARM_CALIBRE' | async}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="lockVersion">
            <mat-header-cell [crud-column-header]="columns.column('lockVersion')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStock.lockVersion">
                Lock Version 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.lockVersion | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="make">
            <mat-header-cell [crud-column-header]="columns.column('make')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStock.make">
                Make 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.make}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="weight">
            <mat-header-cell [crud-column-header]="columns.column('weight')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStock.weight">
                Weight 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.weight}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="currentStockAmount">
            <mat-header-cell [crud-column-header]="columns.column('currentStockAmount')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStock.currentStockAmount">
                Current Stock Amount 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{currentStockAmountDisplay(element)}}
            </mat-cell>
          </ng-container>
          
          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStock.createdBy">
                Created By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdDate">
            <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStock.createdDate">
                Created Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="closed">
            <mat-header-cell [crud-column-header]="columns.column('closed')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStock.closed">
                Closed 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.closed">check_box</mat-icon><mat-icon *ngIf="!element.closed">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit" id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)" mat-raised-button color="primary"
                [routerLink]="viewRoute(element)" i18n="@@actions.view" id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary" [routerLink]="createRoute()"
        [queryParams]="createRouteQueryParams()" i18n="@@actions.create" id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsStocktake()" mat-raised-button color="primary" [routerLink]="stocktakeRoute()"
        [queryParams]="stocktakeRouteQueryParams()" i18n="@@actions.AmmunitionStock.stocktake" id="actions.AmmunitionStock.stocktake">Stocktake</button>
      <button class="action-button" *ngIf="allowsAdditions()" mat-raised-button color="primary" [routerLink]="additionsRoute()"
        [queryParams]="additionsRouteQueryParams()" i18n="@@actions.AmmunitionStock.additions" id="actions.AmmunitionStock.additions">Additions</button>
      <button class="action-button" *ngIf="allowsIssue()" mat-raised-button color="primary" [routerLink]="issueRoute()"
              [queryParams]="issueRouteQueryParams()" i18n="@@actions.AmmunitionStock.issue" id="actions.AmmunitionStock.issue">Issue to Ranger</button>
      <button class="action-button" *ngIf="allowsReturn()" mat-raised-button color="primary" [routerLink]="returnRoute()"
              [queryParams]="returnRouteQueryParams()" i18n="@@actions.AmmunitionStock.return" id="actions.AmmunitionStock.return">Return from Ranger</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>